module.exports = __webpack_public_path__ + "static/media/edit.56051e94.svg";